document.addEventListener('DOMContentLoaded', function () {
  // Sab deferred-media jo autoplay attribute rakhte hain unhe trigger karo
  document.querySelectorAll('deferred-media[autoplay]').forEach(function (media) {
    const playButton = media.querySelector('[ref="deferredMediaPlayButton"]');
    if (playButton) {
      playButton.click(); // play button simulate karo
    } else {
      // Agar button nahi hai toh directly template load karo
      const template = media.querySelector('template');
      if (template) {
        media.appendChild(template.content.cloneNode(true));
      }
    }
  });
});